import React, { useEffect, useState } from 'react';

let deferredPrompt: any = null;

export const InstallPWA: React.FC = () => {
  const [isInstallable, setIsInstallable] = useState(false);
  const [showInstalled, setShowInstalled] = useState(false);

  useEffect(() => {
    // Vérifie si l'app est déjà installée
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstallable(false);
      return;
    }

    // Écoute l'événement beforeinstallprompt
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      deferredPrompt = e;
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    
    // Écoute l'événement appinstalled
    window.addEventListener('appinstalled', () => {
      setIsInstallable(false);
      setShowInstalled(true);
      deferredPrompt = null;
      
      // Cache le message après 3 secondes
      setTimeout(() => {
        setShowInstalled(false);
      }, 3000);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      deferredPrompt = null;
    }
  };

  if (!isInstallable && !showInstalled) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      {isInstallable && (
        <button
          onClick={handleInstallClick}
          className="from-primary-start/90 to-primary-end/90 bg-gradient-to-r text-white px-6 py-2 rounded-full shadow-lg hover:from-primary-start hover:to-primary-end transition-all flex items-center space-x-2"
        >
          <svg 
            className="w-5 h-5" 
            fill="none" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          <span>Installer</span>
        </button>
      )}
      {showInstalled && (
        <div className="bg-green-500/80 text-white px-6 py-2 rounded-full shadow-lg flex items-center space-x-2 animate-fade-out">
          <svg 
            className="w-5 h-5" 
            fill="none" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
          <span>Application installée</span>
        </div>
      )}
    </div>
  );
}; 